import { Catalog as CatalogNamespace } from './lib/catalog';
export var Lib;
(function (Lib) {
    Lib.Catalog = CatalogNamespace;
})(Lib || (Lib = {}));
